import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getStates, UsState } from '../../services/api/geographyService';
import { STATES_CACHE_MS } from './LocationFormLayout';

export interface StateOption {
  value: string;
  label: string;
}

interface UseStateOptionsResult {
  states: UsState[];
  stateOptions: StateOption[];
  isLoading: boolean;
  resolveStateCode: (stateName: string) => string;
  resolveStateName: (stateCode: string) => string;
}

export function useStateOptions(): UseStateOptionsResult {
  const { data: states = [], isLoading } = useQuery({
    queryKey: ['us-states'],
    queryFn: getStates,
    staleTime: STATES_CACHE_MS,
  });

  const stateOptions = useMemo<StateOption[]>(
    () => [
      { value: '', label: 'Select a state' },
      ...states.map((s) => ({ value: s.stateCode, label: s.state })),
    ],
    [states],
  );

  const resolveStateCode = (stateName: string): string =>
    states.find((s) => s.state.toLowerCase() === stateName.toLowerCase())?.stateCode ?? '';

  const resolveStateName = (stateCode: string): string =>
    states.find((s) => s.stateCode === stateCode)?.state ?? '';

  return { states, stateOptions, isLoading, resolveStateCode, resolveStateName };
}
